import { isEmpty } from 'lodash-es';
import { prop } from 'ramda';
import { createSelector } from 'reselect';
import { IS_USE_PLEX_API } from '../../../constants';
import { useGamesSelector } from '../../store';
import { GamesStorageType } from '../../types';
import {
  mapAndFilterGameLaunchIds,
  selectFeedByFeedName,
  selectLaunchIdToGameId
} from '../helpers';

const selectRecentlyPlayedGames = (state: GamesStorageType) =>
  prop('recentlyPlayed')(state);

const EMPTY_ARRAY: string[] = [];

export const selectRecentlyPlayedGamesIds = (
  entityName: string,
  feedName: string
) =>
  createSelector(
    [
      selectLaunchIdToGameId,
      (state) => selectFeedByFeedName(state, feedName),
      selectRecentlyPlayedGames
    ],
    (launchIdToGameId, gamesFeed, recentlyPlayed) => {
      const recentlyPlayedGamesLaunchIds =
        recentlyPlayed?.[entityName]?.ids || [];

      if (IS_USE_PLEX_API) {
        if (isEmpty(recentlyPlayedGamesLaunchIds)) {
          return EMPTY_ARRAY;
        }

        return recentlyPlayedGamesLaunchIds
          .map((gameLaunchId) => launchIdToGameId[gameLaunchId])
          .filter(Boolean);
      }

      if (!gamesFeed?.isLoaded) {
        return EMPTY_ARRAY;
      }
      if (!recentlyPlayedGamesLaunchIds.length) {
        return EMPTY_ARRAY;
      }

      return mapAndFilterGameLaunchIds(
        recentlyPlayedGamesLaunchIds,
        launchIdToGameId,
        gamesFeed.gamesIds || []
      );
    }
  );

export const useGetRecentlyPlayedGamesIds = (
  entityName: string,
  feedName: string
) => {
  return useGamesSelector(selectRecentlyPlayedGamesIds, [entityName, feedName]);
};
